import { Color, Flex, ProgressBar, Spacing } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import { Attachment } from '../../../../../../types/attachment'
import { UploadHeader } from './elements/UploadHeader/UploadHeader'

interface UploadingAttachmentItemProps {
  attachment: Attachment
  onCancel: (id: string) => void
}

export const UploadingAttachmentItem = ({ attachment, onCancel }: UploadingAttachmentItemProps): ReactElement => {
  const { fileName, id, progress, uploadedBytes } = attachment

  const handleCancel = useCallback(() => onCancel(id), [id, onCancel])

  return (
    <Flex flexDirection="column" gap={Spacing.S6} width="100%">
      <UploadHeader fileName={fileName} onCancel={handleCancel} progress={progress} uploadedBytes={uploadedBytes} />
      <ProgressBar
        backgroundColor={Color.Grey100}
        progress={progress}
        progressColor={Color.Purple600}
        size="small"
        withAnimation
      />
    </Flex>
  )
}
